import * as Yup from 'yup';

export const NON_PROD_ENVIRONMENTS = ['development', 'demo', 'stage'];
export const VERIFICATION_CODE_LENGTH = 6;

export const Modes = {
  sms: 'sms',
  totp: 'totp',
} as const;

export type Modes = (typeof Modes)[keyof typeof Modes];

export const SmsDeliveryMethods = {
  sms: 'sms',
  voice: 'voice',
} as const;

export type SmsDeliveryMethods = (typeof SmsDeliveryMethods)[keyof typeof SmsDeliveryMethods];

export const VerificationCodeSchema = Yup.object().shape({
  code: Yup.string()
    .required('is required')
    .matches(/^[0-9]+$/, `Must be exactly ${VERIFICATION_CODE_LENGTH} digits`)
    .length(VERIFICATION_CODE_LENGTH, `Must be exactly ${VERIFICATION_CODE_LENGTH} digits`),
});
